// extracted by mini-css-extract-plugin
export default {"dogStepsContainer":"DogSteps_dogStepsContainer__WTKyV"};